import { UpdateFeeReceiptStatus } from './UpdateFeeReceiptStatus.model';

export class UpdateFeeReceipt {
  SchoolId: number;
  UserId: number;
  UpdateFeeReceiptStatus: UpdateFeeReceiptStatus[];
  UpdateFeeReceiptModel: UpdateFeeReceiptStatus;
  }

